import React, { useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import { getGradeList } from "../../actions/Grade.action";
import { clearTerminalAssessmentRanking } from "../../actions/TerminalAssessmentRanking.action";
import GradeSummary from "../../components/GradeSummary";
import PublicLayout from "../../components/shared/PublicLayout/PublicLayout";
import TerminalAssessmentRankingForm from "../../components/TerminalAssessmentRankingForm/TerminalAssessmentRankingForm";
import TerminalAssessmentRankingHeader from "../../components/TerminalAssessmentRankingHeader/TerminalAssessmentRankingHeader";
import TerminalAssessmentRankingTable from "../../components/TerminalAssessmentRankingTable/TerminalAssessmentRankingTable";

const PublicTerminalAssessmentRankingPage = ({
  terminalAssessmentRanking,
  clearTerminalAssessmentRanking,
  getGradeList,
  grades,
}) => {
  const ref = useRef(null);

  useEffect(() => {
    getGradeList();
  }, [getGradeList]);

  const handleClearData = () => {
    clearTerminalAssessmentRanking();
  };

  return (
    <div className="bg_light">
      <PublicLayout title="Terminal Assessment Ranking">
        <Container>
          <TerminalAssessmentRankingForm grades={grades} publicView={true} />

          {terminalAssessmentRanking.ranking &&
            terminalAssessmentRanking.ranking.success && (
              <div className="mt-4">
                <div ref={ref}>
                  {/* Assessment Header */}
                  <TerminalAssessmentRankingHeader
                    data={terminalAssessmentRanking.ranking}
                    grades={grades}
                  />

                  <TerminalAssessmentRankingTable
                    data={terminalAssessmentRanking.ranking.data}
                  />

                  {/* Grade Summary */}
                  <GradeSummary
                    data={terminalAssessmentRanking.ranking.data}
                    title="Summary"
                  />
                </div>
              </div>
            )}

          {terminalAssessmentRanking.loading && (
            <div className="text-center py-4">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2">Loading ranking data...</p>
            </div>
          )}
        </Container>
      </PublicLayout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  terminalAssessmentRanking: state.terminalAssessmentRanking,
  grades: state.grade.grade,
});

const mapDispatchToProps = {
  clearTerminalAssessmentRanking,
  getGradeList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublicTerminalAssessmentRankingPage);
